import { useQuery } from "@tanstack/react-query";

import { useParams } from "react-router-dom";
import { IProductOffering } from "../types/order";

const API = process.env.REACT_APP_API;

const useProducts = () => {
  const { slug } = useParams();
  const queryFn = async (): Promise<IProductOffering[]> => {
    if (!slug) {
      return [];
    }

    const response = await fetch(
      `${API}/api/feira_online/seeds/${slug}/products-offerings`,
    );
    return (await response.json()) as IProductOffering[];
  };

  return useQuery<IProductOffering[]>({
    queryKey: ["products", slug],
    queryFn,
    enabled: Boolean(slug),
  });
};

export default useProducts;
